var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hmt-video-slideshow"},[_c('video',{attrs:{"controls":"","controlsList":"nodownload noremoteplayback noplaybackrate","disablePictureInPicture":""}},[_c('source',{attrs:{"src":_vm.url,"type":"video/mp4"}}),_vm._v("\n    Your browser does not support the video tag.\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }